export default __webpack_public_path__ + "static/media/spinner.da6beb0d.gif";